"use client";

import { useEffect } from "react";
import {
  initAnalytics,
  identifyUser,
  trackDailyCreditResetClicked,
  trackNextDayReturned,
} from "@/lib/analytics";
import { buildPostHogPersonProperties } from "@/lib/auth-user-metadata";
import { createClient } from "@/lib/supabase/client";

export function PostHogProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    initAnalytics();

    // Daily credit habit-loop funnel (migrations 131/177): attribute landings
    // from the reset notification and record the daily-return signal.
    trackDailyCreditResetClicked();
    trackNextDayReturned();

    // If user is already logged in, identify them with email + name fields
    const supabase = createClient();
    supabase.auth.getUser().then(({ data }) => {
      if (data.user) {
        identifyUser(data.user.id, buildPostHogPersonProperties(data.user));
      }
    });
  }, []);

  return <>{children}</>;
}
